<!--
 * @Author: 汪俊洪
 * @Date: 2023-06-20 19:04:01
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-06-20 19:13:07
 * @Description: 
-->
<template>
  <!-- :disabled="disabledTip" -->
  <el-tooltip
    ref="tlp"
    :content="text"
    effect="dark"
    :disabled="!tooltipFlag"
    :placement="placement"
    class="tooltip"
  >
    <span :class="className" @mouseenter="visibilityChange($event)">{{
      text
    }}</span>
  </el-tooltip>
</template>

<script>
export default {
  name: 'EllipsisTooltip',
  props: {
    text: { type: String, default: '' }, // 字符内容
    placement: { type: String, default: 'top-start' },
    className: { type: String, default: 'text' } // class
  },
  data () {
    return {
      disabledTip: false,
      tooltipFlag: false
    }
  },
  methods: {
    // tooltip的可控
    visibilityChange (event) {
      const ev = event.target
      const evHeight = ev.offsetHeight // 文本的实际高度
      const contentHeight = this.$refs.tlp.$el.parentNode.clientHeight // 文本容器高度
      console.log('contentHeight', contentHeight, 'evHeight', evHeight)
      console.log(contentHeight > evHeight)
      if (contentHeight < evHeight) {
        // 实际内容高度 > 文本高度 =》内容溢出
        this.tooltipFlag = true // NameIsIncludeWord ? true : !!false
      } else {
        // 否则为不溢出
        this.tooltipFlag = false
      }
      console.log('flag:', this.tooltipFlag)
    }
  }
}
</script>
